import Store from '@/vuex/store';
import { parse_flight_offers_date } from '@/utilities';

export const are_filters_active = () => {
  const filter_carriers = Store.state.liveflight.filter_carriers;
  const filter_round_trip_departure = Store.state.liveflight.filter_round_trip_departure;
  const filter_round_trip_arrival = Store.state.liveflight.filter_round_trip_arrival;
  const filter_return_trip_departure = Store.state.liveflight.filter_return_trip_departure;
  const filter_included_bags = Store.state.liveflight.filter_included_bags;
  const filter_extra_bags = Store.state.liveflight.filter_extra_bags;

  return (
    [filter_included_bags, filter_extra_bags].some((b) => b) ||
    [
      filter_carriers,
      filter_round_trip_departure,
      filter_round_trip_arrival,
      filter_return_trip_departure,
    ].some((a) => a.length > 0)
  );
};

function get_filter_date_ranges(filter) {
  let from = 0,
    to = 0;

  // [morning] => 6:00 - 11:59
  if (filter == 'morning') {
    from = 6;
    to = 12;
  }

  // [early_afternoon] => 12:00 - 14:59
  if (filter == 'early_afternoon') {
    from = 12;
    to = 15;
  }

  // [morning] => 15:00 - 17:59
  if (filter == 'late_afternoon') {
    from = 15;
    to = 18;
  }

  // [evening] => 18:00 - 5:59
  if (filter == 'evening') {
    from = 18;
    to = 6;
  }

  return {
    from: from,
    to: to,
  };
}

export function filter_flight_offers() {
  let filter_carriers = Store.state.liveflight.filter_carriers,
    filter_round_trip_departure = Store.state.liveflight.filter_round_trip_departure,
    filter_round_trip_arrival = Store.state.liveflight.filter_round_trip_arrival,
    filter_return_trip_departure = Store.state.liveflight.filter_return_trip_departure,
    filtered_all_carriers = Store.state.liveflight.results.flights,
    filtered = Store.state.liveflight.results.flights,
    filter_included_bags = Store.state.liveflight.filter_included_bags,
    filter_extra_bags = Store.state.liveflight.filter_extra_bags;

  // filtro le flightoffer in base all'orario di partenza del volo di andata
  if (filter_round_trip_departure !== '') {
    let from = get_filter_date_ranges(filter_round_trip_departure).from,
      to = get_filter_date_ranges(filter_round_trip_departure).to;

    filtered = filtered.filter(function (f) {
      let date_object = parse_flight_offers_date(f.itineraries[0].segments[0].departure.at),
        date_hour = parseInt(date_object.hour.split(':')[0]),
        check = false;

      // caso SENZA mezzanotte nel range
      if (filter_round_trip_departure !== 'evening') {
        check = date_hour >= from && date_hour < to;
      }
      // caso CON mezzanotte nel range
      if (filter_round_trip_departure == 'evening') {
        check = (date_hour >= from && date_hour <= 23) || (date_hour >= 0 && date_hour < to);
      }

      return check;
    });
  }

  // filtro le flightoffer in base all'orario di arrivo del volo di andata
  if (filter_round_trip_arrival !== '') {
    let from = get_filter_date_ranges(filter_round_trip_arrival).from,
      to = get_filter_date_ranges(filter_round_trip_arrival).to;

    filtered = filtered.filter(function (f) {
      let last_segment_index = f.itineraries[0].segments.length - 1,
        date_object = parse_flight_offers_date(
          f.itineraries[0].segments[last_segment_index].arrival.at
        ),
        date_hour = parseInt(date_object.hour.split(':')[0]),
        check = false;

      // caso SENZA mezzanotte nel range
      if (filter_round_trip_arrival !== 'evening') {
        check = date_hour >= from && date_hour < to;
      }
      // caso CON mezzanotte nel range
      if (filter_round_trip_arrival == 'evening') {
        check = (date_hour >= from && date_hour <= 23) || (date_hour >= 0 && date_hour < to);
      }

      return check;
    });
  }

  // filtro le flightoffer in base all'orario di partenza del volo di ritorno
  if (filter_return_trip_departure !== '') {
    let from = get_filter_date_ranges(filter_return_trip_departure).from,
      to = get_filter_date_ranges(filter_return_trip_departure).to;

    filtered = filtered.filter(function (f) {
      let date_object = parse_flight_offers_date(
          f.itineraries[f.itineraries.length - 1].segments[0].departure.at
        ),
        date_hour = parseInt(date_object.hour.split(':')[0]),
        check = false;

      // caso SENZA mezzanotte nel range
      if (filter_return_trip_departure !== 'evening') {
        check = date_hour >= from && date_hour < to;
      }
      // caso CON mezzanotte nel range
      if (filter_return_trip_departure == 'evening') {
        check = (date_hour >= from && date_hour <= 23) || (date_hour >= 0 && date_hour < to);
      }

      return check;
    });
  }

  if (filter_included_bags) {
    filtered = filtered.filter(function (f) {
      if (f.travelerPricings[0].fareDetailsBySegment[0].includedCheckedBags) {
        let icb = f.travelerPricings[0].fareDetailsBySegment[0].includedCheckedBags;
        if (icb.quantity && icb.quantity > 0) return true;
        if (icb.weight && icb.weight > 0) return true;
      }
      return false;
    });
  }

  if (filter_extra_bags) {
    filtered = filtered.filter(function (f) {
      let found = false;
      if (f.price.additionalServices) {
        f.price.additionalServices.forEach(function (as) {
          if (as.type == 'CHECKED_BAGS') {
            found = true;
            return;
          }
        });
      }
      return found;
    });
  }

  // mi salvo i risultati filtrati PRIMA dell'applicazione del filtro per carriers, perché ho bisogno dei totali nella sidebar dei filtri
  filtered_all_carriers = filtered;

  // filter by carrier code => visualizzo le flightoffer che abbiano almeno un carrier code di quelli desiderati tra i segmenti del primo itinerario
  if (filter_carriers.length) {
    filtered = filtered.filter((f) =>
      filter_carriers.includes(f.itineraries[0].segments[0].carrierCode)
    );
  }

  return {
    filtered: filtered,
    filtered_all_carriers: filtered_all_carriers,
  };
}
